let uid = 0;

class Deferred {
    constructor() {
        let resolve, reject;
        let promise = new Promise((_resolve, _reject) => {
            resolve = _resolve;
            reject = _reject;
        });

        promise.resolve = resolve;
        promise.reject = reject;
        return promise;
    }
}

export default {
    props: {
        timeout: {
            type: Number,
            default: 5000,
            validator: value => value >= 0,
        },
        showCount: {
            type: Number,
            default: 5,
            validator: value => value >= 0,
        },
        position: {
            type: String,
            default: 'top-right',
            validator: value => ['top-left', 'top-right', 'bottom-left', 'bottom-right', 'top-center'].includes(value)
        },
        useQueue: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            notifications: [],
            queue: [],
            running: false
        };
    },
    methods: {
        add(data) {
            const deferred = new Deferred();
            data.deferred = deferred;
            
            if (this.useQueue) {
                // 使用隊列機制
                this.queue.push(data);
                if (!this.running) {
                    this.processQueue();
                }
            } else {
                // 直接顯示，如果已達到顯示上限，移除最舊的消息
                if (this.notifications.length >= this.showCount) {
                    const oldestNotification = this.notifications.shift();
                    clearTimeout(oldestNotification.timer);

                    this.handleToastClose(oldestNotification);
                }
                
                // 添加新消息
                this.showNotification(data);
            }

            return deferred;
        },
        showNotification(data) {
            // 顯示單個通知
            data.key = uid++;
            data.timer = setTimeout(() => this.remove(data), this.timeout);
            this.notifications.push(data);
        },
        processQueue() {
            if (this.queue.length > 0) {
                this.running = true;
                while (this.queue.length > 0 && this.notifications.length < this.showCount) {
                    const data = this.queue.shift();
                    this.showNotification(data);
                }
            }
            
            if (this.queue.length <= 0) {
                this.running = false;
            }
        },
        remove(data) {
            clearTimeout(data.timer);
            let index = this.notifications.indexOf(data);
            if (index > -1) {
                this.notifications.splice(index, 1);
            }
            
            this.handleToastClose(data);
            
            // 如果使用隊列機制，移除後繼續處理隊列
            if (this.useQueue) {
                this.processQueue();
            }
        },
        clear() {
            // 清除所有通知
            this.notifications.forEach(notification => {
                clearTimeout(notification.timer);
 
                this.handleToastClose(notification);
            });
            this.notifications = [];
            
            // 清除隊列中的項目也要處理 promise
            this.queue.forEach(queueItem => {
                this.handleToastClose(queueItem);
            });
            this.queue = [];
            this.running = false;
        },
        /**
         * 統一處理 toast 結束的方法
         * @param {Object} toastData - toast 數據對象
         */
        handleToastClose(toastData) {
            // emit close 事件
            this.$emit('close', toastData);
            
            // resolve 該 toast 的 promise
            if (toastData.deferred) {
                toastData.deferred.resolve({ toast: toastData });
            }
        }
    },
    beforeDestroy() {
        this.clear();
    }
}; 